import React from 'react';
// import { components } from 'react-select';
import Loader from '../../../general/Loader';
import defaultTheme from '../../../../utils/styles/defaultTheme';
import styles from './../styles';
const newStyles = styles(defaultTheme);
var _ref = /*#__PURE__*/React.createElement(Loader, {
  color: "actionMinor",
  size: "tiny"
});
const LoadingIndicator = props => {
  let className = `${props.className} hoi-poi-select__loading-indicator`;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: newStyles.loadingIndicator
  }, _ref);
};
LoadingIndicator.displayName = 'LoadingIndicator';
export default LoadingIndicator;